import React from "react";
import { Row, Grid } from "react-bootstrap";

import Reference from "./reference/Reference";
import NewReference from "./newReference/NewReference";
import styles from "./References.scss";

class References extends React.Component {
  render() {
    return (
      <Grid className={styles.maxWidth}>
        <Row>
          <div className={styles.memberModerationReferences}>
            <div className={styles.references}>
              <h2 className={styles.header}>References</h2>
              {this.renderReferences()}
            </div>
            <div>
              <NewReference
                workRelations={this.props.workRelations}
                onSubmit={this.props.addReference}
              />
            </div>
          </div>
        </Row>
      </Grid>
    );
  }

  renderReferences() {
    const {
      memberName,
      memberEmail,
      approveReference,
      rejectReference,
      sendReminderReference,
      workRelations
    } = this.props;

    return this.props.references.map((reference, key) => {
      const props = {
        reference,
        memberName,
        memberEmail,
        approveReference,
        rejectReference,
        sendReminderReference,
        workRelations,
        key
      };

      return <Reference {...props} />;
    });
  }
}

export default References;



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/profile/components/references/References.js